export const contractStatuses = {
  cancelled: 'Cancelled',
  extension: 'Extension (90%)',
  inNegotiation: 'In Negotiation (80%)',
  onHold: 'On Hold',
  signed: 'Signed (100%)',
  workAtRisk: 'Work at risk',
  noStatus: 'No status',
} as const;

export type ContractStatus =
  (typeof contractStatuses)[keyof typeof contractStatuses];

export function getSortedContractStatuses() {
  return [
    contractStatuses.signed,
    contractStatuses.extension,
    contractStatuses.inNegotiation,
    contractStatuses.cancelled,
    contractStatuses.onHold,
    contractStatuses.workAtRisk,
    contractStatuses.noStatus,
  ] satisfies ContractStatus[];
}

const sortedContractStatuses = getSortedContractStatuses();
export function getContractStatusSort() {
  return (previous: string, current: string) => {
    return (
      sortedContractStatuses.indexOf(previous as ContractStatus) -
      sortedContractStatuses.indexOf(current as ContractStatus)
    );
  };
}
